import React from 'react';
import SignUpWithEmail from '../components/SignUpV2/SignUpWithEmail';
import action from '../actions/signUp';
import { push } from '../services/routing';
import location from '../services/location';
import { parse } from '../services/queryString';
import routes from '../constants/routes';
import authService from '../services/auth';
import pendo from '../services/pendo';
import Loading from '../components/Layout/Loading';

export const context = 'signUp';

/**
 * @deprecated
 */
export class SignUpRoute extends React.PureComponent {
    state = {
        error: undefined,
        isLoading: true,
    };

    async componentDidMount() {
        const params = parse(location.search);
        if (params.new_signup === undefined) {
            push(routes.SIGN_UP_WITH_EMAIL, { new_signup: '1' });
        }
        try {
            await authService.getProfile();
            push(routes.SIGN_IN);
        } catch (error) {
            if (error.message === 'USER_NOT_LOGGED_IN') {
                this.setState({
                    isLoading: false,
                });
            } else {
                this.setState({ error: error.message });
            }
        }
    }

    render() {
        const { error, isLoading } = this.state;
        if (error) {
            throw error;
        }
        if (isLoading) {
            return <Loading />;
        }

        return (
            <SignUpWithEmail
                action={formData =>
                    action(
                        formData,
                        () => pendo.trackEvent(pendo.buildAnonymousVisitor(), 'Old Sign Up - Form Attempted'),
                        () => pendo.trackEvent(pendo.buildAnonymousVisitor(), 'Old Sign Up - Email Verification Sent')
                    )
                }
                context="signUp"
            />
        );
    }
}

export default SignUpRoute;
